import { BackendError, Service } from '@genial/services';
import {
  V1GetAllBasketCustomerBasketAdvisorRequest,
  V1GetAllBasketOffersBasketAdvisorRequest,
} from '@genial/services/dist/apis';

import { screenName } from '../../../store/batchTicket/constants';
import { blankMetaResponse } from '../../../utils/blankMetaResponse';

export const customerBasketDetailsService = async ({
  basketAdvisorId,
}: V1GetAllBasketCustomerBasketAdvisorRequest) => {
  try {
    const { data } = await Service.Basket.V1.getAllCustomerBasketAdvisor({
      screenName,
      basketAdvisorId,
    });

    return { data };
  } catch (error) {
    const backendError = error as BackendError;

    if (backendError.statusCode === 404) {
      return { data: [], meta: blankMetaResponse() };
    }

    throw error;
  }
};

export const productsBasketDetailsService = async ({
  basketAdvisorId,
}: V1GetAllBasketOffersBasketAdvisorRequest) => {
  try {
    const { data } = await Service.Basket.V1.getAllOffersBasketAdvisor({
      screenName,
      basketAdvisorId,
    });

    return { data };
  } catch (error) {
    const backendError = error as BackendError;

    if (backendError.statusCode === 404) {
      return { data: [], meta: blankMetaResponse() };
    }

    throw error;
  }
};
